import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import TooltipModal from '../mobileTooltipModal/tooltipModal';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import { getTimelineHeadingConfig } from '../../utils/instapoints-timeline/instapoints-timeline';
import {
  TimeLineLabel,
  TimeLineContainer,
  TimelineSeparator,
  MobileTimeLineContainer,
  TimeLineLabelContainer,
  StepContainer,
  ActiveStep,
  StepIPContainer,
  IP,
  ToolTipContainer,
  IPMobileContainer
} from '../../components/timeline/user-flow-timeline.style';
import { getInstapointsLogic } from '../../redux/actions/user-state/user-state-action';
import { APPROVED } from '../../utils/constants';
import { INFO_GREY_ICON } from '@Images';

const RenderStaticTimeline = (props) => {
  const [headingConfig, setheadingConfig] = React.useState(null);
  const [instaNotes, setInstaNotes] = React.useState({});

  useEffect(() => {
    const instaPointsData = async () => {
      if (!props.instaPointsLogicData) await props.getInstapointsLogic();
    };
    instaPointsData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.instaPointsLogicData) {
      let value = getTimelineHeadingConfig(props.instaPointsLogicData, props.user_session, null);
      setheadingConfig(value);
    }
  }, [props.instaPointsLogicData]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (headingConfig) {
      let value = getInstapoints(headingConfig);
      const [initialInstapoinst, totalInstapoinst] = value;
      // eslint-disable-next-line max-len
      const instapointGenralmessage = `Congrats! You have received ${initialInstapoinst} bonus InstaPoints. Complete your profile in next ${props.instaPointsLogicData.acknowledgement_instapoint_hours_limit} hours and get ${totalInstapoinst} extra InstaPoints.`;
      const instapointMessageForAck = `Congrats! You have received ${totalInstapoinst} bonus InstaPoints. `;
      const instapointMessage = instapointGenralmessage;
      setInstaNotes({
        instapointGenralmessage,
        instapointMessageForAck,
        instapointMessage,
        initialInstapoinst,
        totalInstapoinst
      });
    }
  }, [headingConfig]); // eslint-disable-line react-hooks/exhaustive-deps

  const getScreenNameWeb = (label, hederConfig, onlyWidth) => {
    const [initialInstapoinst = null, totalInstapoinst = null] = getInstapoints(hederConfig);
    if (onlyWidth && timerVal && props.userStatusReducer.status !== APPROVED) {
      if (initialInstapoinst && totalInstapoinst) {
        return '79%';
      }
      return null;
    }
    switch (label) {
      case 'Sign Up':
        return timerVal && initialInstapoinst ? `Sign Up with ${initialInstapoinst}   ` : 'Sign Up';
      case 'Send':
        return 'Recipient & amount';
      case 'Recipient':
        return 'Payment method';
      case 'Documents':
        return 'Verify';
      case 'Acknowledgement':
        return timerVal && totalInstapoinst
          ? `   Acknowledge with ${totalInstapoinst}`
          : 'Acknowledge';
      default:
        return label;
    }
  };

  const getInstapoints = (hederConfig) => {
    const signUpHeading = get(hederConfig, 'signUpHeading', null);
    if (!signUpHeading) {
      return;
    }
    return signUpHeading.reduce((acc, pre) => {
      if (pre.title === 'Sign Up Bonus' || pre.title === 'Total') {
        return [...acc, pre.value];
      }
      return acc;
    }, []);
  };

  const timerVal = '35h 25m left';
  const timeline = [
    {
      label: 'Sign Up',
      timeline_sequence: -1,
      status: 'completed',
      key: 'sign_up'
    },
    {
      label: 'Personal',
      timeline_sequence: 1,
      status: 'processing',
      key: 'personal'
    },
    {
      label: 'Documents',
      timeline_sequence: 2,
      status: 'pending',
      key: 'documents'
    },
    {
      label: `Acknowledge with ${instaNotes && instaNotes.totalInstapoinst}`,
      timeline_sequence: 3,
      status: 'pending',
      key: 'acknowledgement'
    }
  ];
  const activeStep = timeline.length - 2;

  return (
    <div className="timeline">
      <div className="form-proccess-top-main desktop-timeline">
        <div className="timeline-slider-wrapper">
          <MobileTimeLineContainer>
            <StepIPContainer>
              <StepContainer>
                Step
                <ActiveStep>{activeStep}</ActiveStep>/{timeline.length}
                <ActiveStep>Personal</ActiveStep>
              </StepContainer>
              {timerVal && (
                <IPMobileContainer>
                  <IP>
                    {`instapoints ${
                      instaNotes &&
                      instaNotes.initialInstapoinst &&
                      instaNotes.initialInstapoinst.replace('IPs', '').trim()
                    }`}
                    <span>{`/${instaNotes && instaNotes.totalInstapoinst}`}</span>
                  </IP>
                  <TooltipModal
                    triggerContent={
                      <img src={INFO_GREY_ICON} alt="address tooltip" width="10px" height="10px" />
                    }
                    title={'InstaPoints'}
                    content={instaNotes && instaNotes.instapointMessage}
                  />
                </IPMobileContainer>
              )}
            </StepIPContainer>
          </MobileTimeLineContainer>
        </div>
        <div className="timeline-list new-timeline">
          <div className="timeline-wrapper" style={{ display: 'flex', justifyContent: 'center' }}>
            <TimeLineContainer id="time-line-container">
              {timeline.map((i, j) => {
                return (
                  <>
                    <TimeLineLabelContainer key={j}>
                      <TimeLineLabel id={i.status} status={i.status} key={j}>
                        {headingConfig && getScreenNameWeb(i.label, headingConfig)}
                      </TimeLineLabel>
                    </TimeLineLabelContainer>
                    {j < timeline.length - 1 && <TimelineSeparator></TimelineSeparator>}
                  </>
                );
              })}
              {timerVal && (
                <ToolTipContainer>
                  <Popup
                    position="bottom right"
                    content={
                      <div
                        style={{
                          fontFamily: 'hellix-regular',
                          fontSize: '9px',
                          fontWeight: 'normal',
                          fontStretch: 'normal',
                          fontStyle: 'normal',
                          lineHeight: '1.56',
                          letterSpacing: 'normal',
                          color: '#202859'
                        }}
                      >
                        {instaNotes && instaNotes.instapointMessage}
                      </div>
                    }
                    trigger={
                      <img src={INFO_GREY_ICON} alt="address tooltip" width="10px" height="10px" />
                    }
                  />
                </ToolTipContainer>
              )}
            </TimeLineContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

RenderStaticTimeline.propTypes = {
  instaPointsLogicData: PropTypes.any,
  getInstapointsLogic: PropTypes.func,
  user_session: PropTypes.object,
  userStatusReducer: PropTypes.object
};

function mapStateToProps(reduxState) {
  const {
    rootReducer: {
      userFlowReducer: { screens, currentScreen, timeline },
      userSessionReducer: { user_session },
      userDataReducer: {
        instaPointsLogicData,
        userStateInfo: { remitterDetails },
        savedAadharData
      },
      userStatusReducer
    }
  } = reduxState;
  return {
    screens,
    currentScreen,
    timeline,
    user_session,
    instaPointsLogicData,
    remitterDetails,
    userStatusReducer,
    savedAadharData
  };
}

export default connect(mapStateToProps, { getInstapointsLogic })(RenderStaticTimeline);
